import axios from 'axios'

export default {
  get (url) {
    return axios
      .get(url)
  },

  post (url, params) {
    return axios
      .post(url, params)
  },

  put (url, params) {
    return axios
      .put(url, params)
  },

  delete (url, params) {
    return axios
      .delete(url)
  },

  patch (url, params) {
    return axios
      .patch(url, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/request.js